export default "__VITE_ASSET__Bt9Bu9pw__"